<template>
  <section class="main-box">
    <!--工具条-->
    <el-row>
      <el-col :span="24">
        <el-form :inline="true" :model="filters" ref="param">
          <el-form-item label="项目">
            <ProjectList @proSelected="proChange"></ProjectList>
          </el-form-item>
          <el-form-item>
            <el-input v-model="filters.searchTab" placeholder="按考试名称搜索"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" v-on:click="doSearch()">查询</el-button>
            <el-button v-on:click="showAddView()" type="success">添加</el-button>
<!--            <a href="javascript:void(0)" class="download" @click="download('/xml/exam_model.xlsx')">[点击下载试题模板]</a>-->
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>

    <!--列表-->
    <template>
      <el-table :data="data" highlight-current-row v-loading="loading">
        <el-table-column type="index" label="序号" width="100" align="center">
        </el-table-column>
        <el-table-column prop="examName" label="考试名称" align="center">
        </el-table-column>
        <el-table-column prop="examBeginTime" label="开考时间" align="center" :formatter="formatDate">
        </el-table-column>
        <el-table-column prop="examEndTime" label="结束时间" align="center" :formatter="formatDate">
        </el-table-column>
        <el-table-column prop="examAllFen" label="试卷总分" align="center">
        </el-table-column>
        <el-table-column prop="allUserNum" label="参与人数" align="center">
          <template slot-scope="scope">
            <div class="confirmBtn"
                 @click="showUser(scope.row.id)">{{scope.row.allUserNum}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="考试状态" align="center" :formatter="formatStatus">
        </el-table-column>
        <el-table-column prop="status" label="二维码" align="center">
          <template slot-scope="scope">
            <el-button size="small" v-if="scope.row.status ==1" @click="qrcodeView(scope.$index, scope.row)">查看</el-button>
          </template>
        </el-table-column>
<!--        <el-table-column prop="createTime" label="创建时间" align="center" :formatter="formatDate">-->
<!--        </el-table-column>-->
        <el-table-column label="操作" width="300" align="center">
          <template slot-scope="scope">

            <el-button size="small" v-if="scope.row.status ==0" @click="changeStatus(scope.$index, scope.row,1)">开考</el-button>
            <el-button size="small" v-if="scope.row.status ==1" @click="changeStatus(scope.$index, scope.row,0)">关闭</el-button>

            <el-button size="small" @click="openDetails(scope.$index, scope.row)">查看</el-button>
            <el-button size="small" @click="showEditView(scope.$index, scope.row)">编辑</el-button>
            <el-button type="danger" size="small" @click="doDel(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="prev, pager, next" @current-change="searchPage" :page-size="limit" :total="total"
                       class="layout-right">
        </el-pagination>
      </el-col>
    </template>
    <!-- 表单视图 -->
    <el-dialog title="" :visible.sync="formVisible" :close-on-click-modal="false" :modal="false">
      <div v-if="formVisible">
        <ExamForm :option="option" :form-data="formData" @doSubmit="doSubmit" @doCancel="doCancel"></ExamForm>
      </div>
    </el-dialog>
    <!-- 详情界面 -->
    <el-dialog :title="formData.examName+'----试卷总分:'+formData.examAllFen+'分'" :width="width" :visible.sync="detailsVisible" :modal="false" class="details" :close-on-click-modal="false">
      <div v-if="detailsVisible">
       <ExamView :form-data="formData" :qu-data="quData" @doSubmit="doSubmit" @doCancel="doCancel" :type="0"></ExamView>
      </div>
    </el-dialog>
    <!--已参与考试的人员-->
    <el-dialog :visible.sync="userVisible" :modal="false" ref="userDialog" title="已参与考试人员" :close-on-click-modal="false">
      <div class="m-baox">
        <table class="m-mess" cellspacing="1">
          <tr class="trbg">
            <td class="">姓名</td><td class="">岗位</td><td>得分</td>
          </tr>
          <tr class="tdbg"  v-for="(item,index) in examUser" :key="index">
            <td align="left">{{item.create_name}}</td>
            <td align="left">{{item.role_names}}</td>
            <td>{{item.exam_all_fen}}(分)</td>
          </tr>
        </table>
      </div>
    </el-dialog>

    <!-- 二维码视图 -->
    <el-dialog :visible.sync="qrcodeVisible" title="查看二维码" :modal="false" :close-on-click-modal="false">
      <div class="q-title" style="text-align: center">{{qrcodeMes}}</div>
      <div slot="footer">
        <div id="qrcode"></div>
      </div>
    </el-dialog>
  </section>
</template>
<script>
  import { examDel, examSearch, examDetail,examStatus,examQues,doExamMes,proSearch} from '../../api/api'
  import ExamForm from "./ExamForm";
  import ExamView from "./ExamView";
  import ProjectList from "../command/ProjectList";
  import QRCode from 'qrcodejs2'
  export default {
    components: {ProjectList, ExamView, ExamForm},
    data() {
      return {
        proId:null,
        filters: {},
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        loading: false,
        total: 2,
        page: 1,
        limit: 15,
        data: [],
        formData: {},
        formVisible: false,
        detailId: null,
        option:0,
        detailsVisible: false,
        width:'90%',
        quData:[],
        userVisible:false,
        examUser:[],
        proList:[],
        qrcodeVisible:false,
        qrcodeMes:null,
      }
    },
    methods: {
      //查询
      searchData: function () {
        this.GLOBAL.checkRole(this.GLOBAL.fun.examCreate, this.GLOBAL.option.select, this);
        this.loading = true;
        this.filters.page = this.page;
        this.filters.limit = this.limit;//请求参数
        if (this.filters.searchTab == '') {
          this.filters.searchTab = null;
        }
        this.filters.proId = this.proId == '' ? null : this.proId;
        this.filters.comId = this.GLOBAL.user.comId;
        examSearch(this.filters, this.GLOBAL.header).then(result => {
          if (result.success) {
            this.data = result.data.result;
            this.total = result.data.total;
            this.loading = false;
          }
        });
      },
      doSearch: function () {
        this.searchData()
      },
      resetForm: function () {
        this.filters = {}
      },
      searchPage: function (val) {
        this.page = val;
        this.searchData();
      },
      formatDate: function (row, column) {
        if(column.property == 'examBeginTime')
          return this.GLOBAL.formatTimeToStr(row.examBeginTime, "yyyy-MM-dd hh:mm:ss");
        if(column.property == 'examEndTime')
          return this.GLOBAL.formatTimeToStr(row.examEndTime, "yyyy-MM-dd hh:mm:ss");
        if(column.property == 'createTime')
          return this.GLOBAL.formatTimeToStr(row.createTime, "yyyy-MM-dd hh:mm:ss");
      },
      formatStatus: function (row, column) {
        return row.status == 0 ? '未开考' :  '开考';
      },
      showUser:function(id){
        doExamMes({id: id}, this.GLOBAL.header).then(result => {
          if (result.success) {
            this.examUser = result.data;

            this.userVisible = true;
          }
        });
      },
      //========================================
      //添加视图
      showAddView: function () {
        let res = this.GLOBAL.checkRole(this.GLOBAL.fun.examCreate, this.GLOBAL.option.create, this);
        if (res) {
          this.option = 0;
          this.formData = {}
          this.formVisible = true;
        }
      },
      //编辑视图
      showEditView: function (index, row) {
        let res = this.GLOBAL.checkRole(this.GLOBAL.fun.examCreate, this.GLOBAL.option.update, this);
        if (res) {
          this.option = 1;
          this.detailId = row.id;
          examDetail({id: row.id}, this.GLOBAL.header).then(result => {
            if (result.success) {
              this.formData = result.data;
              this.formVisible = true;
            }
          });
        }
      },
      //表单提交后回调
      doSubmit: function () {
        this.searchData();
        this.formVisible = false;
        this.detailsVisible = false;
      },
      //表单取消后回调
      doCancel: function () {
        this.formVisible = false;
        this.detailsVisible = false;
      },
      //删除
      doDel: function (index, row) {
        let res = this.GLOBAL.checkRole(this.GLOBAL.fun.examCreate, this.GLOBAL.option.delete, this);
        if (res) {
          this.$confirm('确认删除该记录吗?', '提示', {
            type: 'warning'
          }).then(() => {
            examDel({id: row.id}, this.GLOBAL.header).then(result => {
              if (result.success) {
                this.$message({
                  message: "删除成功",
                  type: 'success'
                });
                this.searchData();
              }
            });
          }).catch(() => {
          });
        }
      },
      //查看详情
      openDetails: function (index, row) {
        let res = this.GLOBAL.checkRole(this.GLOBAL.fun.examCreate, this.GLOBAL.option.message, this);
        if (res) {
          examDetail({id: row.id}, this.GLOBAL.header).then(result => {
            if (result.success) {
              this.formData = result.data;
              if(this.formData!=null){

                examQues({quNo:this.formData.examQuestion}, this.GLOBAL.header).then(result => {
                  if (result.success) {
                    this.quData = result.data;
                    // console.log(this.quData)
                    this.detailsVisible = true;
                  }
                });
              }

              this.detailsVisible = true;
            }
          });

        }
      },
      changeStatus:function(index, row,s){
        let res = this.GLOBAL.checkRole(this.GLOBAL.fun.examCreate, this.GLOBAL.option.status, this);
        if (res) {
          let p = {};
          p.id = row.id;
          p.status = s;
          examStatus(p, this.GLOBAL.header).then(result => {
            if (result.success) {
              this.searchData();
            }
          });
        }
      },
      //=====下载文件方法====================================================
      download: function (file) {
        if (file != null && file != '') {
          let url = this.GLOBAL.baseDocumentPath + file;    // 获取图片地址
          let a = document.createElement('a');          // 创建一个a节点插入的document
          let event = new MouseEvent('click')       // 模拟鼠标click点击事件
          a.download = 'beautifulGirl'                  // 设置a节点的download属性值
          a.href = url;                                 // 将图片的src赋值给a节点的href
          a.dispatchEvent(event)                        // 触发鼠标点击事件
        }
      },
      proChange:function(proId){
        this.proId = proId;
        this.doSearch();
      },
      qrcodeView(index, row) {
        this.qrcodeVisible = true
        this.qrcodeMes = row.examName;
        this.qrcode.makeCode(this.GLOBAL.baseDomainUrl + '/examview?id=' + row.id);
      },
      showQEcodeView: function () {
        this.qrcode = new QRCode('qrcode', {
          width: 150, //图像宽度
          height: 150, //图像高度
          colorDark: '#000000', //前景色
          colorLight: '#ffffff', //背景色
          typeNumber: 4,
          correctLevel: QRCode.CorrectLevel.H //容错级别 容错级别有：（1）QRCode.CorrectLevel.L （2）QRCode.CorrectLevel.M （3）QRCode.CorrectLevel.Q （4）QRCode.CorrectLevel.H
        })
      },
    },
    mounted() {
      this.showQEcodeView();
    }
  };
</script>
<style scoped>
  .confirmBtn {
    width: 50px;
    height: 20px;
    margin: auto;
    background: #55c03c;
    border-radius: 20px;
    cursor: pointer;
    color: #ffffff;
  }
  .m-baox{
    overflow-y: scroll;
    height: 500px;
  }
  .m-mess{
    margin: auto;
    width: 500px;
    background: #b8b8b8;

  }
  .m-mess tr {
    height: 30px;
    text-align: center;
  }
  .trbg {
    background: #DDE5D4
  }
  .tdbg td {
    background: #f8f8f8
  }
  .download {
    text-decoration: none;
    color: blue;
    margin-left: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/exam/Exam.vue